import React, { Component } from 'react';
import {Route} from "react-router-dom";
import {withStyles} from "@material-ui/styles";
import {Spinner} from "../common/Spinner";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import GridItem from "../common/dashboard/GridItem.js";
import Card from "../common/dashboard/Card.js";
import CardBody from "../common/dashboard/CardBody.js";
import CardHeader from "../common/dashboard/CardHeader.js";
import CardIcon from "../common/dashboard/CardIcon.js";
import {NotificationContainer} from "react-notifications";
import CardMui from "@material-ui/core/Card";
import {AccessTime} from "@material-ui/icons";
import CardFooter from "../common/dashboard/CardFooter";
import CustomerComplaints from "./CustomerComplaints";
import CustomerNumbers from "./CustomerNumbers";
import CorrectiveActions from "./CorrectiveActions";
import dashboardStyle from "../common/dashboard/dashboardStyle.js";
import {GreenButton} from "../common/ButtonsConstants";
import * as CommonUtils from "../../util/CommonUtils";

const classes = (() => ({
    ...dashboardStyle,
    root: {
        width: '100%',
        overflowX: 'auto',
        padding: '30px',
    },
}));

class Leadership extends Component {

    constructor(props) {
        super(props);
        this.state = {
            latestRevision: {},
            isLoading: true,
            isEditCustomerComplaints: false,
            isEditCustomerNumbers: false,
            isEditActions: false,
            complaintsButtonLabel: 'Customize',
            customerNumbersButtonLabel: 'Customize',
            actionsButtonLabel: 'Customize',
        };
        this.editCustomerComplaints = this.editCustomerComplaints.bind(this);
        this.editCustomerNumbers = this.editCustomerNumbers.bind(this);
        this.editActions = this.editActions.bind(this);
        this.onChanged = this.onChanged.bind(this);
    }

    onChanged(customerComplaints) {
        console.log(customerComplaints);
    }

    editCustomerComplaints() {
        console.log('this.state.isEditCustomerComplaints', this.state.isEditCustomerComplaints);
        let newVal = !this.state.isEditCustomerComplaints;
        this.setState({
            isEditCustomerComplaints: newVal,
            complaintsButtonLabel: newVal ? 'Redraw' : 'Customize'
        });
        return false;
    }

    editCustomerNumbers() {
        let newVal = !this.state.isEditCustomerNumbers;
        this.setState({
            isEditCustomerNumbers: newVal,
            customerNumbersButtonLabel: newVal ? 'Redraw' : 'Customize'
        });
        return false;
    }

    editActions() {
        let newVal = !this.state.isEditActions;
        this.setState({
            isEditActions: newVal,
            actionsButtonLabel: newVal ? 'Redraw' : 'Customize'
        });
        return false;
    }

    render() {
        let { state } = this;
        const { classes } = this.props;
        let isAuditor = CommonUtils.isAuditor(this.props.currentUser);
        return <div className="mui-container-fluid">
            <Route path={`/leadership` }>
                <CardMui className={classes.card}>
                        <hr/>
                        <Paper className={classes.root}>
                            <Typography component="h2" variant="h5">
                                <span style={{color: "darkblue"}}>
                                    <p><b>LEADERSHIP</b></p>
                                </span>
                            </Typography>
                            <Grid container>
                                <GridItem xs={12} sm={12} md={6}>
                                    <Card chart>
                                        <CardBody>
                                            <p className={classes.cardCategory} style={{ float: "right" }}><GreenButton disabled={isAuditor} onClick={this.editCustomerComplaints} type="submit">{this.state.complaintsButtonLabel}</GreenButton></p>
                                            <h3 className={classes.cardTitle}>Customer Complaints</h3>
                                        </CardBody>
                                        <CardHeader>
                                            <CustomerComplaints isEdit={this.state.isEditCustomerComplaints} onChanged={this.onChanged}/>
                                        </CardHeader>
                                        <CardFooter chart>
                                            <div className={classes.stats}>
                                                <AccessTime /> generated {new Date().toLocaleDateString()}
                                            </div>
                                        </CardFooter>
                                    </Card>
                                </GridItem>
                                <GridItem xs={12} sm={12} md={6}>
                                    <Card chart>
                                        <CardBody>
                                            <p className={classes.cardCategory} style={{ float: "right" }}><GreenButton disabled={isAuditor} onClick={this.editActions} type="submit">{this.state.actionsButtonLabel}</GreenButton></p>
                                            <h3 className={classes.cardTitle}>Nonconformance/corrective action reports</h3>
                                        </CardBody>
                                        <CardHeader>
                                            <CorrectiveActions isEdit={this.state.isEditActions} onChanged={this.onChanged}/>
                                        </CardHeader>
                                        <CardFooter chart>
                                            <div className={classes.stats}>
                                                <AccessTime /> generated {new Date().toLocaleDateString()}
                                            </div>
                                        </CardFooter>
                                    </Card>
                                </GridItem>
                            </Grid>
                            <Grid container>
                                <GridItem xs={12} sm={12} md={6}>
                                    <Card chart>
                                        <CardBody>
                                            <p className={classes.cardCategory} style={{ float: "right" }}><GreenButton disabled={isAuditor} onClick={this.editCustomerNumbers} type="submit">{this.state.customerNumbersButtonLabel}</GreenButton></p>
                                            <h3 className={classes.cardTitle}>Customers Numbers</h3>
                                        </CardBody>
                                        <CardHeader>
                                            <CustomerNumbers isEdit={this.state.isEditCustomerNumbers} onChanged={this.onChanged}/>
                                        </CardHeader>
                                        <CardFooter chart>
                                            <div className={classes.stats}>
                                                <AccessTime /> generated {new Date().toLocaleDateString()}
                                            </div>
                                        </CardFooter>
                                    </Card>
                                </GridItem>
                            </Grid>
                            {/*<Grid>
                                <GridItem xs={12} sm={12} md={6}>
                                    <Card>
                                        <CardHeader color="rose" icon>
                                            <CardIcon color="rose">
                                                <Language />
                                            </CardIcon>
                                        </CardHeader>
                                        <CardBody>
                                            <h4 className={classes.cardTitle}>Here is the Icon</h4>
                                            The place is close to Barceloneta Beach and bus stop just 2 min by
                                            walk and near to "Naviglio" where you can enjoy the main night
                                            life in Barcelona...
                                        </CardBody>
                                    </Card>
                                </GridItem>
                            </Grid>*/}
                            <NotificationContainer/>
                        </Paper>
                </CardMui>
            </Route>
        </div>;
    }
}

export default withStyles(classes)(Leadership);